import { RouteRecordRaw } from 'vue-router'

// 学员画像模块路由
const studentPortraitRoutes: RouteRecordRaw = {
  path: '/student-portrait',
  name: 'StudentPortrait',
  component: () => import('@/views/StudentPortrait/index.vue'),
  meta: {
    title: '学员画像',
    icon: 'user-portrait'
  }
}

export default studentPortraitRoutes 